import type { FaireProductEntity } from "../../entity_types/product";

export const p_97744k3y95: FaireProductEntity = {
  token: "p_97744k3y95",
  type: "product",
  name: "Pina Colada Frozen Cocktail -Just add Water + Rum",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/2202d75f234d3cd354fd325105b2d3589921a7ba45dc3649d12a438db3a95c17.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80268d1da36896da0f0709bc9a59390940792bdb122d1a7a7b543c7106941f0b.png",
    "https://cdn.faire.com/fastly/c039a4388772335ecbdf69eb6868741dd4b1fdde5a58bd31339bfd1f5a933a1c.png",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 12 oz of rum and 36 oz of water, shake or stir and throw in the freezer. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party. \nCheers from Noble Mick's\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:04.661Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
